export const createMyListsRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
